import endpoints from '@app/src/api/endpoints'
import { useUpdateResource } from '@app/src/api/updateHooks'
import useErrorNotification from '@app/src/hooks/errorNotification'
import type { ExpectationAutomation, ExpectationAutomationPayload } from '@app/src/types/expectations'
import { buildSubmissionPayload } from './expectationAutomationLogic'
import type { ExpectationAutomationFormData } from './types'

const useSaveExpectationAutomation = () => {
  const { mutateAsync: saveAutomation, isPending } = useUpdateResource<
    ExpectationAutomation,
    ExpectationAutomationPayload & { id?: number }
  >()
  const { showErrorNotification } = useErrorNotification()

  const saveExpectationAutomation = async (
    values: ExpectationAutomationFormData,
    assessmentTemplateId: number,
    onSuccess: () => void,
  ) => {
    const body = buildSubmissionPayload(values, assessmentTemplateId)

    await saveAutomation(
      { url: endpoints.expectationAutomation, body },
      {
        onSuccess,
        onError: error => {
          showErrorNotification({ requestError: error })
        },
      },
    )
  }

  return {
    saveExpectationAutomation,
    isExpectationAutomationLoading: isPending,
  }
}

export default useSaveExpectationAutomation
